<template>
  <div class="sms-modal">
    <Drawer title="选择重新生成项" :width="70" v-model="stepFirstShow">
      <div class="main" style="margin-bottom: 15px">
        <RemarkCard>
          <p style="margin-bottom: 8px">
            ①账单重新生成即表示对原始生成的账单进行变更，确认后系统即清空原始账单数据，并显示最新生成后的数据，该操作<span
              class="color-red"
              >不可恢复</span
            >，请操作前仔细核对！
          </p>
          <p>
            ②您还可以在操作前，选择下载当前数据，进行保存。点击立即<span
              class="color-red"
              >下载进行保存。</span
            ><Button type="primary" size="small" @click="handleDownload"
              >立即下载账单明细</Button
            >
          </p>
        </RemarkCard>
        <p style="padding-top: 8px">
          <Checkbox v-model="whetherSettlementFee" disabled
            >重新生成课程费</Checkbox
          >
        </p>
        <div class="flex" style="width: 100%">
          <div class="flex" style="width: 400px">
            <span>课程费结算月份：</span>
            <div style="width: 68%; margin-bottom: 4px">
              <strong>{{ yearMonth }}</strong>
            </div>
          </div>
          <div>
            <span>课程费日期区间：</span>
            <!-- :value="dateTime" -->
            <DatePicker
              type="datetimerange"
              placeholder="请选择日期期间"
              style="width: 330px"
              :value="courseDate"
              @on-change="onCourseDateChange"
              format="yyyy-MM-dd"
              :options="optionsCourse"
              :clearable="false"
              :start-date="new Date(beginTime)"
            ></DatePicker>
          </div>
        </div>
        <p style="color: red; font-size: 13px">
          提示：重新生成的结算月份需确保该机构/学校唯一，同月份不可存在多个账单。
        </p>

        <p style="padding-top: 8px">
          <Checkbox v-model="includeStatementTallyType"
            >重新生成材料费</Checkbox
          >
        </p>
        <p>
          <span>材料费日期区间：</span>
          <!-- :value="dateTime" -->
          <DatePicker
            type="datetimerange"
            placeholder="请选择日期期间"
            style="width: 330px"
            @on-change="onDateChange"
            :value="materialDate"
            format="yyyy-MM-dd"
            :options="optionsCourse"
            :clearable="false"
            :start-date="new Date(beginTime)"
          ></DatePicker>
        </p>
        <p class="color-red" style="margin-bottom: 8px">
          提示：材料费重新生成，默认结算日期区间内，未结算的首节（第1个课时）的材料。如材料费是分多课时结算，请手动选择其他课时。
        </p>
        <Button
          type="primary"
          size="small"
          @click="handleViewMaterials"
          style="margin-bottom: 8px"
          >+ 手动添加其他课时的材料结算</Button
        >
        <Table
          :columns="tableColumns"
          :data="materialsList"
          border
          :max-height="500"
          ><template slot="action" slot-scope="{ row, index }">
            <Button type="error" size="small" @click="handleRemove(row, index)"
              >删除</Button
            >
          </template>
        </Table>
      </div>
      <div class="modal-430-bottom">
        <Button @click="handleSmsCancle">取消</Button>
        <Button type="primary" @click="handleSmsSubmit">确定</Button>
      </div>
    </Drawer>

    <Modal
      v-model="showExportModal"
      :mask-closable="false"
      title="正在导出"
      @on-cancel="handleCancelExport"
    >
      <Progress :percent="percent" :stroke-width="5"></Progress>
      正在导出表格，请给我一些时间
      <div slot="footer">
        <Button @click="handleCancelExport">取消</Button>
      </div>
    </Modal>
    <SendSms ref="sendSmsRef" @on-finish="onSendSmsFinish"> </SendSms>
    <ViewSettleMaterials
      ref="viewSettleMaterialsRef"
      :orgId="detailsData.data.orgId"
      :yearCode="detailsData.yearCode"
      :termCode="detailsData.termCode"
      :yearTermStr="detailsData.yearTerm"
      :endTime="specifiedStatementTallyTimeEnd"
      :beginTime="specifiedStatementTallyTimeBegin"
      @on-finish="onMaterialsFinish"
    ></ViewSettleMaterials>
  </div>
</template>

<script>
import common from '@/request/common/index';
import { fliterPhone } from '@/utils/utils';
import orderCenterApi from '@/request/orderCenter/index.js';
import { getNextMonth, timeToTimestamp, getMonthFinalDay } from '@/utils/moment.js'
import RemarkCard from '@c/Base/RemarkCard.vue';
import { deepCopy } from '@/utils/utils.js'
import cateringAdmin from '@/request/cateringAdmin/index.js';
import SendSms from '@/components/Base/SendSms.vue'
import ViewSettleMaterials from './ViewSettleMaterials.vue'

let IntervalId;
export default {
  name: 'sms-modal',

  props: {
    // statementId: {
    //   type: String,
    //   default: ''
    // },
    beginTime: {
      type: String,
      default: ''
    },

    titleStr: {
      type: String,
      default: ''
    },
  },
  components: {
    SendSms,
    RemarkCard,
    ViewSettleMaterials
  },
  inject: ['detailsData', 'tableType', 'type'],
  data() {
    let _this = this
    return {
      optionsCourse: {
        disabledDate(date) {
          timeToTimestamp(`${getNextMonth(`${_this.yearMonth}-01`)} 00:00:00`)

          return date && date.valueOf() >= timeToTimestamp(`${getNextMonth(`${_this.yearMonth}-01`)} 00:00:00`);
        }
      },
      showExportModal: false,

      stepFirstShow: false,
      whetherSettlementFee: true,
      includeStatementTallyType: false,
      specifiedStatementTallyTimeBegin: '',
      specifiedStatementTallyTimeEnd: '',
      statementEndTime: '',
      statementBeginTime: '',
      dateTime: ['', ''],
      courseDate: [], // 课程费日期区间
      materialDate: [], // 材料费日期区间
      credential: null,
      downloadUrl: '', // 下载地址
      downloadToken: '',
      percent: 0,
      portOrg: localStorage.getItem('portOrg'),
      statementIds: '',
      yearMonth: '',
      userIp: '',
      materialsList: [],
      tableColumns: [{
        type: 'index',
        width: 60,
        align: 'center'
      }, {
        title: '材料费名称',
        key: 'materialName'
      }, {
        title: '关联课程商品',
        key: 'offerName'
      }, {
        title: '结算课时(可结算)',
        width: 100,
        key: 'withholdTimes'
      }, {
        title: '结算金额(可结算)(元)',
        width: 120,
        key: 'withholdAmount'
      }, {
        title: '操作',
        slot: 'action',
        width: 100,
        align: 'center'
      }],

    }
  },
  watch: {
    beginTime: {
      handler: function (newVal) {
        this.yearMonth = newVal.substring(0, 7)
        let time = this.yearMonth.split('-')
        let endDay = getMonthFinalDay(time[0], time[1]), startDay = `${this.yearMonth}-01`
        this.courseDate = [startDay, endDay]
        this.materialDate = [startDay, endDay]
        this.onCourseDateChange(this.courseDate)
        this.onDateChange(this.materialDate)
        //  this.dateTime = [newVal, `${getNextMonth(newVal.substring(0, 10))} 00:00:00`]
      },
      immediate: true
    }
  },
  created() {

  },
  methods: {
    handleShow() {
      this.stepFirstShow = true
      if (!this.userIp) {
        common.getIpAddr().then(res => {
          this.userIp = res.message
        })
      }

    },

    onSendSmsFinish(info) {
      this.phoneCode = info.phoneCode
      this.credential = info.credential
      this.resetBillingOperations()
    },
    // 课程费日期区间
    onCourseDateChange(time) {
      this.statementBeginTime = time[0] ? `${time[0]} 00:00:00` : ''
      this.statementEndTime = time[1] ? `${time[1]} 23:59:59` : ''
    },
    // 时间期间
    onDateChange(time) {
      this.specifiedStatementTallyTimeBegin = time[0] ? `${time[0]} 00:00:00` : ''
      this.specifiedStatementTallyTimeEnd = time[1] ? `${time[1]} 23:59:59` : ''

    },
    handleSmsCancle() {
      this.stepFirstShow = false
    },
    // 打开材料费
    handleViewMaterials() {
      let info = deepCopy(this.materialsList)
      this.$refs.viewSettleMaterialsRef.open(info)
    },
    // 删除
    handleRemove(row, index) {
      this.materialsList.splice(index, 1);
    },
    // 
    checkForm() {
      let data = {
        code: 200,
        info: {
        }
      };
      if (this.whetherSettlementFee && !this.statementBeginTime) {
        data.code = 501
        this.$Message.warning('请选择课程费日期区间！');
        return data
      }
      if (this.includeStatementTallyType && !this.specifiedStatementTallyTimeBegin) {
        data.code = 501
        this.$Message.warning('请选择日期区间！');
        return data
      }
      return data
    },
    handleSmsSubmit() {

      let result = this.checkForm()
      if (result.code != 200) {
        return
      }
      this.stepFirstShow = false
      this.$refs.sendSmsRef.handleShow()

    },
    // 导出取消
    handleCancelExport() {
      console.log('取消');
      this.showExportModal = false;
    },
    percentShowFun() {
      this.percent += 20;
      if (this.percent >= 80) {
        clearInterval(IntervalId);
      }
    },
    percentShow() {
      this.percent = 0;
      IntervalId = setInterval(this.percentShowFun, 500);
    },
    // 获取任务id
    async getTaskId(parameter) {
      return new Promise(async (resolve, reject) => {
        let res;
        // switch (Number(this.portOrg)) {
        //   case 0:

        res = await orderCenterApi.getUserOrderTaskIdByAdmin(parameter);
        if (res.data.status == 200) {
          resolve(res.data.message);
        }
        //     break;
        // }
      });
    },
    // 下载处理
    async handleDownload(data) {
      const parameter = { port: 1, queryMode: 2, acctPlatType: this.detailsData.data.bankId, schoolId: '', orgId: this.detailsData.data.orgId, yearMonth: this.yearMonth, areaName: this.titleStr, pageNum: 1, pageSize: 10000, addr: this.userIp, statementId: this.detailsData.sheetId, sheetId: this.detailsData.sheetId, statementIds: '' };
      let res;
      const taskId = await this.getTaskId(parameter);
      try {
        var source = new EventSource(`${process.env.VUE_APP_EVENT_SOURCE}/sse/subscribe?id=${taskId}`);
        this.percentShow();
        this.showExportModal = true;
        setTimeout(async () => {
          switch (Number(this.portOrg)) {
            case 0:
              res = await orderCenterApi.downloadProductTallyOrderDetailList(parameter);
              break;
            case 1:
              res = await orderCenterApi.downloadProductTallyOrderDetailListByEdu(parameter);
              break;

            case 2:
              res = await orderCenterApi.downloadProductTallyOrderDetailListBySch(parameter);
              break;
            case 3:
              res = await orderCenterApi.downloadProductTallyOrderDetailListByOrg(parameter);
              break;
          }
        }, 3000);
        // 回调
        source.onopen = event => {
          console.log(event, '通道打开=====');
        };
        source.onmessage = async event => {
          console.log('event.data', event);

          const { resultContent, taskStatus } = JSON.parse(event.data);
          //  0 待处理 1 处理中 2处理成功 9处理异常
          if (taskStatus === 2) {
            this.$Message.success('导出成功');
            clearInterval(IntervalId);
            this.percent = 100;
            setTimeout(() => {
              this.showExportModal = false;
            }, 500);
            const infoData = JSON.parse(resultContent)[0];
            const { fileId, name } = infoData;
            // await this.getDownloadtoken();
            // downloadReport(this.downloadUrl, { fileId, token: this.downloadToken });
            // return;
            const downloadElement = document.createElement('a');
            await this.getDownloadtoken(fileId);
            const href = `${this.downloadUrl}?fileId=${fileId}&token=${this.downloadToken}`;
            downloadElement.style.display = 'none';
            downloadElement.href = href;
            downloadElement.download = name; // 下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); // 点击下载
            document.body.removeChild(downloadElement); // 下载完成移除元素
            source.close();
          }
          if (taskStatus === 9) {
            clearInterval(IntervalId);
            this.percent = 60;
            setTimeout(() => {
              this.showExportModal = false;
            }, 500);
            this.$Message.error('导出失败');
          }
        };
      } catch (err) {
        clearInterval(IntervalId);
        this.percent = 60;
        setTimeout(() => {
          this.showExportModal = false;
        }, 500);
        this.$Message.error('导出失败');
      }
    },
    async resetBillingOperations() {
      this.$Spin.show();
      let attachmentList = this.materialsList.map(item => { return { settleTimes: item.withholdTimes, payOrderId: item.offerOrderId } })

      let res = await orderCenterApi.resetBillingOperations({
        statementId: this.detailsData.sheetId,
        sheetId: this.detailsData.sheetId,
        whetherSettlementFee: this.whetherSettlementFee,
        statementBeginTime: this.statementBeginTime,
        statementEndTime: this.statementEndTime,
        includeStatementTallyType: this.includeStatementTallyType,
        specifiedStatementTallyTimeBegin: this.specifiedStatementTallyTimeBegin,
        specifiedStatementTallyTimeEnd: this.specifiedStatementTallyTimeEnd,
        verifyCode: this.phoneCode,
        credential: this.credential,
        attachmentList: attachmentList
      })
      this.$Spin.hide();
      if (res.status == 200) {
        this.$Modal.success({
          title: '温馨提示',
          content: '账单重新生成成功!',
          onOk: () => {
            //this.stepSecondShow = false
            this.$refs.sendSmsRef.handleHide()
            this.$emit('on-reset')
          },
        });
      } else if (res.status != '3505' && res.status != '3504') {
        this.$Modal.error({
          title: '温馨提示',
          content: '账单重新生成失败！请联系技术解决!',
          onOk: () => {
            this.stepSecondShow = false
            this.$emit('on-reset')
          },
        });
      }
    },
    // 下载token
    async getDownloadtoken(fileId) {
      return new Promise(async (resolve, reject) => {
        const params = {
          fileId: [fileId],
          type: 2
        };
        const res = await cateringAdmin.getDownloadtoken(params);
        if (res.status === 200) {
          this.downloadUrl = res.message.downUrl;
          this.downloadToken = res.message.token;
        }
        resolve();
      });
    },
    onMaterialsFinish(materialsList) {
      this.materialsList = materialsList
    },
  },
}
</script>

<style lang="scss" scoped>
</style>